import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import MyLikedVideos from '../../../modals/components/layouts/student-dashboard/EditStudentProfile/MyLikedVideos/MyLikedVideos';

export default function LikedVideos() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate
        title={t('left_side_bar.liked_videos')}
        content={<MyLikedVideos />}
      />
    </Grid>
  );
}
